import * as React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { RouteNameEnum } from '../enums/routeName';
import usePermission from '../hooks/usePermission';

interface PrivateOutletProps {
  permissionCodes?: string[];
  redirectUrl?: string;
}

const PrivateOutlet: React.FC<PrivateOutletProps> = (props) => {
  const { permissionCodes, redirectUrl } = props;
  const { isAuthenticated } = useAuth();
  const { checkPermission } = usePermission();
  if (!isAuthenticated) {
    return <Navigate to={RouteNameEnum.auth.login} />;
  }
  if (permissionCodes?.length && !checkPermission(permissionCodes)) {
    return <Navigate to={redirectUrl || RouteNameEnum.dashboard.index} />; // default redirect home
  }

  return <Outlet />;
};

PrivateOutlet.defaultProps = {
  permissionCodes: [],
  redirectUrl: undefined,
};

export default PrivateOutlet;
